

import __layout_0 from '/opt/atlassian/pipelines/agent/build/src/layouts/default.vue'
export const layouts = {
'default': __layout_0,
'full-page': () => import('/opt/atlassian/pipelines/agent/build/src/layouts/full-page.vue'),
}

export function setupLayouts(routes) {
  return routes.map(route => {
    return { 
      path: route.path,
      meta: route.meta,
      component: layouts[route.meta?.layout || 'default'],
      children: route.path === '/' ? [route] : [{...route, path: ''}]
    }
  })
}
